/* eslint-disable no-unassigned-import */

window.addEventListener('vite:preloadError', event => {
  event.preventDefault()
  window.location.reload()
})

import {router, rqContext} from '@/router'
import {LanguageSync} from '@/shared/integrations/tolgee/LanguageSync'
import {Zero} from '@/shared/integrations/zero'
import {client} from '@cypro/server/client'
import {ThemeProvider} from '@cypro/ui/components'
import {TanstackQuery} from '@cypro/ui/integrations/tanstack-query'
import {Tolgee} from '@cypro/ui/integrations/tolgee'
import {RouterProvider} from '@tanstack/react-router'
import {StrictMode, Suspense} from 'react'
import ReactDOM from 'react-dom/client'

import 'react-phone-number-input/style.css'

client.setConfig({
  baseUrl: '/api',
  credentials: 'include',
})

// oxlint-disable-next-line no-non-null-assertion
const rootElement = document.getElementById('app')!

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <Suspense fallback={null}>
        <TanstackQuery.Provider {...rqContext}>
          <Zero.Provider>
            <Tolgee.Provider>
              <LanguageSync />
              <ThemeProvider>
                <RouterProvider router={router} context={{...rqContext}} />
              </ThemeProvider>
            </Tolgee.Provider>
          </Zero.Provider>
        </TanstackQuery.Provider>
      </Suspense>
    </StrictMode>
  )
}
